import styled from 'styled-components';

export default styled.div`
  width: 100%;
  max-width: 720px;
  display: flex;
  margin-top: 9px;
  align-items: ${(p) => (p.center ? 'center' : 'flex-start')};

  > div:nth-child(1) {
    padding-top: 4px;
    flex: 0 0 150px;
    text-align: right;
  }
  > div:nth-child(2) {
    margin-left: 20px;
    width: 100%;
    max-width: 380px;
  }
  > button:nth-child(2) {
    margin-left: 20px;
    width: 100%;
    max-width: 380px;
  }

  @media (max-width: 720px) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    margin: 0 auto;
    > div:nth-child(1) {
      padding-top: 0px;
      text-align: left;
      flex: 0;
    }
    > div:nth-child(2) {
      margin-left: 0;
    }
    > button:nth-child(2) {
      margin-left: 0;
    }
  }
`;
